import { render, staticRenderFns } from "./ActiveDevices.vue?vue&type=template&id=063d957a&scoped=true"
import script from "./ActiveDevices.vue?vue&type=script&lang=js"
export * from "./ActiveDevices.vue?vue&type=script&lang=js"
import style0 from "./ActiveDevices.vue?vue&type=style&index=0&id=063d957a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d957a",
  null
  
)

export default component.exports